import {createGlobalStyle} from "styled-components";
import {styleReset} from "react95";

// Windows95 font (optional)
import ms_sans_serif from "react95/dist/fonts/ms_sans_serif.woff2";
import ms_sans_serif_bold from "react95/dist/fonts/ms_sans_serif_bold.woff2";

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'ms_sans_serif';
    src: url('${ms_sans_serif}') format('woff2');
    font-weight: 400;
    font-style: normal;
    font-size: 400px;
  }
  @font-face {
    font-family: 'ms_sans_serif';
    src: url('${ms_sans_serif_bold}') format('woff2');
    font-weight: bold;
    font-style: normal;
    font-size: 400px;
  }
  body {
    font-family: 'ms_sans_serif';
    font-size: 400px;
  }
  ${styleReset}
`;

export default GlobalStyles;
